export default __webpack_public_path__ + "static/media/close.36478870.svg";